import React, { Fragment } from "react";
import "./styles/homeTablet.css";

//provider
import { stateAdmison } from "../Context/store";
import { PAGINA_INICIO, PAGINA_UNO } from "../rutas";

//components
import { LayoutTablet } from "./LayoutTablet";


//pages
import { HomePageTablet } from "./HomePageTablet";

//activos
import HeaderImageRigthSvg from "../../../Activos/Imagenes/Modulos/Home/HeaderImageRigth.svg";
import ImageHomeLeftBottom from "../../../Activos/Imagenes/Modulos/Home/ImageHomeLeftBottom.svg";

export const HomeTablet = () => {
  const { navigatioPage } = stateAdmison();

  return (
    <Fragment>
      <div className={ navigatioPage === PAGINA_INICIO  ? "home-container" : undefined}>
       {navigatioPage === PAGINA_INICIO ?  <div className="container-header-img">
          <img
            className="img-background-tablet"
            src={HeaderImageRigthSvg}
            alt={"Avatar de HeaderRigth"}
          />
        </div> : null }
        {navigatioPage === PAGINA_INICIO ? <HomePageTablet /> : null}

        {navigatioPage === PAGINA_UNO ? <LayoutTablet /> : null}

        {navigatioPage === PAGINA_INICIO ? (
          <img
            className="img-left-bottom"
            src={ImageHomeLeftBottom}
            alt={"."}
          />
        ) : null}
      </div>
    </Fragment>
  );
};
